import qs from "qs";

export function handleSend(axios, options) {
  if (options.method === "get") {
    axios.get(options.url, { params: { ...options.data, _: new Date().getTime() } });
  } else {
    // console.log("options.data", options.data);
    // for (let i in options.data) {
    //   if (Array.isArray(options.data[i])) {
    //     if (options.data[i].length === 0) {
    //       options.data[i] = null;
    //     }
    //   }
    // }
    axios.post(options.url, qs.stringify({ ...options.data, _: new Date().getTime() }));
    //console.log("qs.stringify", qs.stringify({ ...options.data }));
  }
}
